import React from 'react';

export const GlobeCross = ({ width = 16, height = 16, className = '' }) => (
  <svg
    width={width}
    height={height}
    className={className}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_36937_593230)">
      <path
        d="M13.9524 8.754C14.1056 7.54483 13.8869 6.31769 13.3254 5.2359C12.7639 4.15411 11.8862 3.26897 10.8093 2.6983C9.73228 2.12763 8.50704 1.89849 7.29661 2.04138C6.08618 2.18426 4.94797 2.6924 4.03347 3.49816C3.11897 4.30391 2.47155 5.36907 2.17738 6.55187C1.88321 7.73467 1.95624 8.97901 2.38674 10.1193C2.81725 11.2596 3.58482 12.2417 4.5873 12.9349C5.58977 13.6282 6.7796 13.9997 7.99844 14"
        stroke="#6B7280"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.39941 6H13.5994"
        stroke="#6B7280"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.39941 10H8.99941"
        stroke="#6B7280"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.66726 2C6.54415 3.79974 5.94873 5.87858 5.94873 8C5.94873 10.1214 6.54415 12.2003 7.66726 14"
        stroke="#6B7280"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.33252 2C9.64565 4.10345 10.2323 6.57966 10.0025 9.04867"
        stroke="#6B7280"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.6659 14.6665L11.3325 11.3331"
        stroke="#6B7280"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.3325 14.6665L14.6659 11.3331"
        stroke="#6B7280"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_36937_593230">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
